import moment from 'moment';
import type { TFunction } from 'i18next';

// Минуты одной записи таймшита — округление вверх до 5 минут (как на десктопе).
export const entryMinutes = (r: any): number => {
  const diff = moment(r.endTime).diff(moment(r.startTime), 'minutes');
  return Math.max(0, Math.ceil(diff / 5) * 5);
};

// Локализованное отображение длительности: "8h" / "8h 30m" (единицы из i18n: hShort/mShort).
export const fmtDuration = (min: number, t: TFunction): string => {
  const h = Math.floor(min / 60);
  const m = min % 60;
  const hu = t('hShort');
  const mu = t('mShort');
  return m === 0 ? `${h}${hu}` : `${h}${hu} ${String(m).padStart(2, '0')}${mu}`;
};
